<template>
    <DashboardGraph :icons="icons" :title="title" :chart_type="chart_type" :chart_handle="chart_layout" :load_url="load_url" :options="options" :options_text="options_text"></DashboardGraph>
</template>

<script>
    import DashboardGraph from '../../widgets/DashboardGraph';
    export default {
        name: 'InventoryPiecesProcessedL2PChart',
        components: {DashboardGraph},
        data() {
            var labels = [];
            for(var i = 8; i <= 17;i++){
                labels[i-8] = 'Hour '+i;
            }
            return {
                icons:labels,
                chart_type: 'bar',
                color: '#76d561',
                title: 'Inventory Pieces Processed PL2',
                load_url: '/dashboards/InventoryPiecesProcessedL2P',
                time_wait: 10000,
                options: ['today', 'yesterday','last7days','this_month','last_month'],
                options_text: ['Today', 'Yesterday','Last 7 Days','This Month','Last Month'],
                chart_layout: [
                    {
                        'label': 'Inventory pieces processed',
                        'backgroundColor': 'rgb(33,41,213)', //can be an array for other graph types
                        'borderColor': 'rgba(220, 220, 220, 1)',
                        'pointBackgroundColor': 'rgba(220, 220, 220, 1)',
                        'pointBorderColor': '#fff',
                        'pointHighlightFill': '#fff',
                        'pointHighlightStroke': 'rgba(220, 220, 220, 1)',
                    },
                ],
            };
        },
    };
</script>

<style scoped>

</style>